<template>
  <modal name="warning-modal-buy" class="warning-modal" :adaptive="true" :clickToClose="false">
    <div class="warning">
      <img :src="icon" v-if="icon">
      <h2 class="title">Произошла ошибка</h2>
      <p class="desc">Зарегистрируйтесь в системе кинотеатра, в котором хотите купить билет, или повторите попытку позже</p>
      <div class='crm-modal-buttons'>
        <button v-if='!user.isRegistrationInWidget' @click.prevent="toRegistration">
          <p>Зарегистрироваться</p>
        </button>
        <button @click.prevent="hide()">
          <p>Повторить позже</p>
        </button>
      </div>
    </div>
  </modal>
</template>

<script>
/* eslint-disable */

import axios from 'axios';
import { setting } from '@/setting';
import { eventBus } from '@/main.js';
import { mapState } from 'vuex';

export default {
  name: 'WarningModalBuy',
  props: ['disabled', 'icon', 'title', 'text'],

  computed: {
    ...mapState(['user'])
  },

  methods: {
    hide() {
      this.$modal.hide('warning-modal-buy');
    },
    toRegistration() {
      this.hide()
      this.$modal.show('registration-form');
    }
  },
};
</script>

<style lang="scss">

.v--modal-background-click {
  display: flex;
  justify-content: center;
  align-items: center;
}

.v--modal-box.v--modal {
  position: initial !important;
  top: auto !important;
  left: auto !important;
  right: auto !important;
  bottom: auto !important;
  width: min-content !important;
  max-width: calc(100% - 30px) !important;
  min-width: 40% !important;
  height: auto !important;
  max-height: calc(100% - 30px) !important;
  border-radius: 8px;
  padding: 15px 25px;
  border-radius: 8px;
  line-height: 1.45;
  color: white;
  background: rgba(13,118,255,.9) !important;
}

.v--modal-box.v--modal .warning {
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  width: 100%;
}

.v--modal-box.v--modal .warning img {
  width: 128px;
  padding: 25px 0;
  margin: 0 auto;
  fill: white;
}

.v--modal-box.v--modal .warning button {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 16px;
  height: 40px;
  border: 2px solid #fff;
  border-radius: 25rem;
  background: white;
  line-height: 1.45;
  cursor: pointer;
  transition: all .15s 150ms;
}

.v--modal-box.v--modal .warning button:hover {
  opacity: .75;
}

.v--modal-box.v--modal .warning h2 {
  font-size: 20px;
  font-weight: 600;
}

.v--modal-box.v--modal .warning p {
  padding: 15px 0;
}

@media only screen and (max-width: 768px), only screen and (max-width: 768px) and (max-height: 650px) {
  .v--modal-box.v--modal {
    position: relative !important;
    width: calc(100% - 30px) !important;
    max-width: initial !important;
    min-width: initial !important;
    min-height: 200px !important;
    max-height: calc(100% - 30px) !important;
    padding: 10px !important;
    z-index: 99999 !important;
  }

  .v--modal-box.v--modal .warning img {
    width: 64px !important;
  }

  .v--modal-box.v--modal .warning h2 {
    font-size: 16px;
  }

  .v--modal-box.v--modal .warning p {
    font-size: 14px;
  }
}

@media only screen and (max-height: 480px) {
  .v--modal-overlay .v--modal-box.v--modal {
    position: relative !important;
    height: 200px !important;
    max-height: calc(100% - 30px) !important;
    padding: 10px !important;
    z-index: 99999 !important;
  }

  .v--modal-box.v--modal .warning img {
    width: 64px !important;
  }

  .v--modal-box.v--modal .warning h2 {
    font-size: 16px;
  }

  .v--modal-box.v--modal .warning p {
    font-size: 14px;
  }
}

.crm-modal-buttons {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 10px;

  button {
    min-width: 220px;
  }
}


</style>
